import { render, staticRenderFns } from "./CauHinhBaoMatOtp.vue?vue&type=template&id=416fa7bd&scoped=true&"
import script from "./CauHinhBaoMatOtp.vue?vue&type=script&lang=js&"
export * from "./CauHinhBaoMatOtp.vue?vue&type=script&lang=js&"
import style0 from "./CauHinhBaoMatOtp.vue?vue&type=style&index=0&id=416fa7bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416fa7bd",
  null
  
)

export default component.exports